import angular from 'angular';
import React from 'react';
import ReactDOM from 'react-dom';
import { withProviders } from '../../../modules/core/components';
import Price from '../../../modules/core/components/price';
// how to use for angular -> react-global-price(item="premium-yearly-v1" currency="USD" region="US")
export default angular
    .module('doxy.common.components.reactGlobalPrice', [])
    .component('reactGlobalPrice', {
    template: `<div></div>`,
    bindings: {
        item: '@',
        currency: '@',
        region: '@?'
    },
    controller: function ($element) {
        const render = () => {
            const props = {
                item: isNaN(Number(this.item)) ? this.item : Number(this.item),
                currency: this.currency || 'USD',
                region: this.region,
            };
            ReactDOM.render(React.createElement(withProviders(Price), props), $element[0]);
        };
        this.$onChanges = render;
    }
}).name;
